import styled from "styled-components";
import { TriangleArrow } from "../arrows/triangle-arrow";

// tslint:disable-next-line
export const ManagerSearchFilterArrowDown = styled(TriangleArrow)`
  position: absolute;
  top: 42%;
  left: 30%;
`;
